var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 90,
    viewBox: "0 0 134 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 89.2396V59.1284C0 35.9286 9.96717 14.5632 17.2134 11.1967C49.5 -3.8034 77 -3.80337 111.257 11.6282C120.224 15.6678 128 45.1282 128 59.1284V89.2396C126.847 88.3944 125.503 87.7656 123.948 87.3929C123.983 86.0451 124 84.6827 124 83.3062C124 36.9238 104.169 12 64 12C23.8312 12 4 36.9238 4 83.3062C4 84.6827 4.01747 86.0451 4.05241 87.3929C2.49732 87.7656 1.15329 88.3944 0 89.2396Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.986 57.9932C68.1838 57.5602 25.6308 36.5235 24.0458 2.00859C23.9952 0.905183 24.9466 -8.76786e-06 26.0512 1.40134e-05C133.168 0.00222325 133.995 0.352724 134 55.9606C134 57.0651 133.09 58.0007 131.986 57.9932Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9997 57.9195C19.7725 56.4739 31.5371 35.6401 31.9866 2.00993C32.0014 0.905455 31.0848 -0.000388857 29.9802 0.000578955C0.3634 0.0265289 0.00440598 1.21749 5.34058e-05 55.9606C-3.43323e-05 57.0651 0.898767 58.009 1.9997 57.9195Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairD);
export default __webpack_public_path__ + "static/media/Hair D.84fcd9326eb6ed67c7b3639240319c98.svg";
export { ForwardRef as ReactComponent };